import {
    Box,
    Card,
    CardContent,
    Typography,
    IconButton,
    Divider,
    AppBar,
    Toolbar
} from "@mui/material";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { useAudio } from "../component/AudioProvider";

const History = () => {

    const userId = "1"; // TODO: Replace this with dynamic user ID from auth context

    const [songs, setSongs] = useState([]);
    const [historyData, setHistoryData] = useState([]);

    useEffect(() => {
        // Fetch all songs first
        axios.get("https://music-endpoint.onrender.com/songs/getallsongs")
            .then(response => {
                setSongs(response.data.data || []);
            })
            .catch(console.error);
    }, []);

    useEffect(() => {
        // Fetch history after songs are loaded
        if (songs.length === 0) return;

        axios.get(`https://music-endpoint.onrender.com/api/history/${userId}`)
            .then(response => {
                const history = response.data;

                const formatted = history.map(item => {
                    const song = songs.find(s => s.songId.toString() === item.songId.toString());
                    return {
                        ...item,
                        playedAt: dayjs(item.listenedAt),
                        songTitle: item.songTitle || song?.songName || "Unknown Song",
                        artist: item.artist || song?.artist || "Unknown Artist",
                    };
                });

                setHistoryData(formatted);
            })
            .catch(console.error);
    }, [songs]);



    const groupByTime = () => {
        const today = [];
        const yesterday = [];
        const earlier = [];

        historyData.forEach(item => {
            const now = dayjs();
            if (item.playedAt.isSame(now, 'day')) {
                today.push(item);
            } else if (item.playedAt.isSame(now.subtract(1, 'day'), 'day')) {
                yesterday.push(item);
            } else {
                earlier.push(item);
            }
        });

        return { today, yesterday, earlier };
    };

    const { today, yesterday, earlier } = groupByTime();

    const { tracks, playTrack } = useAudio();

    const handlePlayAgain = (song) => {
        const index = tracks.findIndex(t => t.songId === song.songId);
        if (index !== -1) {
            playTrack(index);
        }
    };

    // const handleDelete = (id) => {
    //     setHistoryData(prev => prev.filter(song => song.id !== id));

    //     axios
    //         .delete(`https://music-endpoint.onrender.com/api/history/${id}`)
    //         .catch(error => console.error("Failed to delete history entry:", error));
    // };

    const renderSongs = (songs) => (
        songs.map(song => (
            <Box key={song.id} sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 1,
                borderBottom: "1px solid #eee"
            }}>
                <Box>
                    <Typography variant="subtitle1" noWrap>{song.songTitle}</Typography>
                    <Typography variant="body2" color="text.secondary">{song.artistName}</Typography>
                </Box>
                <Box>
                    <IconButton onClick={() => handlePlayAgain(song)} color="primary">
                        <PlayArrowIcon />
                    </IconButton>
                </Box>
            </Box>
        ))
    );

    return (
        <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
            <AppBar position="static" sx={{ mb: 2, backgroundColor: "#121212" }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between",height: "87px" }}>
                    <Typography variant="h5" sx={{ color: "#F0F3F5" }}>
                        Your Listening History 🎵
                    </Typography>
                    <Typography variant="h4" sx={{ color: "#F0F3F5", fontWeight: "bold" }}>
                        EUMAK
                    </Typography>
                </Toolbar>
            </AppBar>

            <Box sx={{ px: 3 }}>
                {today.length > 0 && (
                    <Card sx={{ mb: 3 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>Today</Typography>
                            <Divider />
                            {renderSongs(today)}
                        </CardContent>
                    </Card>
                )}

                {yesterday.length > 0 && (
                    <Card sx={{ mb: 3 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>Yesterday</Typography>
                            <Divider />
                            {renderSongs(yesterday)}
                        </CardContent>
                    </Card>
                )}

                {earlier.length > 0 && (
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>Earlier</Typography>
                            <Divider />
                            {renderSongs(earlier)}
                        </CardContent>
                    </Card>
                )}

                {(today.length === 0 && yesterday.length === 0 && earlier.length === 0) && (
                    <Typography variant="body1" sx={{ mt: 4, textAlign: "center" }}>
                        No listening history available.
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default History;
